import { mapGetters, mapState } from 'vuex';
import baseApiAddress from '@/axios.config';

export default {
    data() {
        return {
            showItems: false,
            showProjectSummaryBottomSheet: false,
            showNotification: false,
            notificationMessage: '',
            notificationStatus: '',
            nextServiceTitle: '',
            savingService: false
        };
    },
    computed: {
        ...mapGetters([
            'orderMediaDetailsVS',
            'imageServices',
            'VSReferencePhoto',
            'VSComments',
            'commentsHaveChangedVS',
            'refPhotoHasChangedVS',
            'roomTypeHasChanged',
            'selectedStylesHaveChanged',
            'multiCataloguesHaveChanged',
            'singleCataloguesHaveChanged',
            'vsMode',
            'saveButtonTextVS',
            'vsHasChanged',
            'vsLoadingXS',
            'selectedRoomTypes',
            'selectedStyles',
        ]),
        ...mapState(['virtualStagingStore', 'vsStore']),
        checkForChanges() {
            if (
                this.commentsHaveChangedVS ||
                this.refPhotoHasChangedVS ||
                this.roomTypeHasChanged ||
                this.selectedStylesHaveChanged ||
                this.multiCataloguesHaveChanged ||
                this.singleCataloguesHaveChanged
            ) {
                return true;
            }
            return false;
        },
        advancePric() {
            const services_prices = JSON.parse(sessionStorage.getItem('services_prices'));
            const { firstPrice } = services_prices.VS;
            const { multiplePrice, singlePrice } = this.vsStore;
            if (singlePrice > 0 || multiplePrice > 0) {
                return multiplePrice + singlePrice + firstPrice;
            }
            return 0;
        },

        serviceData() {
            const {
                vsMode,
                selectedRoomTypes,
                selectedStyles,
                selectedSingleCatalogues,
                selectedMultipleCatalogues,
            } = this.vsStore;
            let single = [],
                multiple = [],
                vsServices = [],
                styles = [],
                roomTypesId = [];

            selectedRoomTypes.map((item) => {
                roomTypesId.push(item.id);
            });
            selectedStyles.map((item) => {
                styles.push({
                    _id: item._id,
                    output: item.numOfOutput,
                    VS_Type: 'style',
                    style_id: item.id,
                    roomTypes: roomTypesId,
                });
            });
            selectedSingleCatalogues.map((item) => {
                single.push({
                    _id: item._id,
                    delete: item.delete ? true : '',
                    output: 1,
                    VS_Type: 'single',
                    catalogs: [item.id],
                });
            });
            for (let i = 0; i < selectedMultipleCatalogues.length; i++) {
                let cataloguesArray = [];
                let deleteMulti = '';

                if (
                    selectedMultipleCatalogues[i].length === 1 &&
                    Object.keys(selectedMultipleCatalogues[i][0]).length === 1
                ) {
                    multiple.push({
                        delete: true,
                        _id: selectedMultipleCatalogues[i][0]._id,
                    });
                } else {
                    selectedMultipleCatalogues[i].map((item) => {
                        cataloguesArray.push(item.id);
                    });

                    multiple.push({
                        _id:
                            selectedMultipleCatalogues[i][0]._id &&
                                selectedMultipleCatalogues[i][0]._id.length > 0
                                ? selectedMultipleCatalogues[i][0]._id
                                : '',
                        output: 1,
                        delete: deleteMulti,
                        VS_Type: 'multi',
                        catalogs: cataloguesArray,
                    });
                }

                cataloguesArray = [];
            }
            if (vsMode === 'style') {
                styles.map((style) => {
                    vsServices.push(style);
                });
            } else {
                single.map((item) => {
                    vsServices.push(item);
                });
                multiple.map((item) => {
                    vsServices.push(item);
                });
            }

            const dataVS = {
                order_id: this.orderMediaDetailsVS.order_id,
                media_details_id: this.orderMediaDetailsVS._id,
                type: 'VS',
                service_details: {
                    comments: this.VSComments,
                    references: this.VSReferencePhoto,
                },
                services: vsServices,
            };
            return dataVS;
        },
        selectedImgSrc() {
            const { src } = this.orderMediaDetailsVS;
            return `${process.env.VUE_APP_BASE_IMAGE_SRC}${src.split('.')[0]}_500.${src.split('.')[1]
                }`;
        },
    },
    methods: {
        editComment(id, text) {
            const dispatchData = {
                id,
                text,
            };
            this.$store.commit('editVSComments', dispatchData);
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
        deleteComment(id) {
            this.$store.commit('deleteIEComments', id);
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
        addComment(description) {
            let comment = [
                {
                    id: 1,
                    positionX: 0,
                    positionY: 0,
                    content: description,
                },
            ];
            this.$store.commit('addToVSComments', comment);
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
        async saveNavigateProjectSummary() {
            this.saveVsServiceChanges('project-summary');
        },
        navigateToProjectSummary() {
            if (this.vsHasChanged) {
                if (this.$mq === 'sm' || this.$mq === 'md') {
                    this.showProjectSummaryBottomSheet = true;
                } else {
                    this.$modal.show('go-to-project-summary');
                }
                return;
            }
            this.$router.push('/project-overview');
        },
        saveChangesButton() {
            if (this.saveButtonTextVS === 'Apply') {
                this.saveVsServiceChanges('show-modal');
                return;
            }
            this.goToNextPhoto();
        },
        async goToNextPhoto() {
            const projectId = this.$cookies.get('project-id');
            const { data, status } = await baseApiAddress({
                method: 'get',
                url: `/orders/new-order/medias?order_id=${Number(projectId)}`,
            });
            if (status >= 200 && status < 300) {
                this.$store.commit('setReferencePhotoVS', 'reset reference');
                const { orderMedias } = data.data;
                const imageId = this.$route.params.id.split('=')[1];
                const mediaIndex = orderMedias.findIndex((media) => {
                    return media._id === imageId;
                });
                const slicedMedia = orderMedias.slice(mediaIndex + 1);

                if (mediaIndex === orderMedias.length - 1) {
                    this.$router.push('/project-overview');
                    return;
                }
                const nextMediaIndex = slicedMedia.findIndex((media) => {
                    return media.media_type === '2D';
                });
                const nextPhoto = slicedMedia[nextMediaIndex];
                if (nextMediaIndex >= 0) {
                    window.location.href = `${process.env.BASE_URL}virtual-staging/image_id=${nextPhoto._id}`;
                    return;
                }
                this.$router.push('/project-overview');
            }
        },
        async saveVsServiceChanges(type) {
            try {
                if (this.selectedStyles.length > 0) {
                    // this.$store.commit('handleVsLoadingXS', true);
                    this.savingService = true;
                    const { status, data } = await baseApiAddress({
                        method: 'post',
                        url: '/orders/new-order/add-service',
                        data: this.serviceData,
                    });
                    if (status >= 200 && status < 300) {
                        this.$store.commit('setReferencePhotoVS', 'reset reference');
                        this.$store.commit('handleVSChanges', false);
                        this.$store.commit('setSaveButtonTextVS', 'next-photo');
                        this.$store.commit('setOrderMediaDetailsVS', data.data.orderMediaDetails);
                        // this.$store.commit('handleVsLoadingXS', false);
                        this.savingService = false;

                        let styleData = {};
                        styleData.style = {};
                        this.$store.commit('SET_SELECTED_STYLE', styleData);

                        const { services } = data.data;
                        services.map((service) => {
                            styleData.type = 'add';
                            styleData.style = {
                                id: service.style[0].id,
                                name: service.style[0].name,
                                src: service.style[0].src,
                                numOfOutput: service.output,
                                _id: service._id,
                            };
                            this.$store.commit('SET_SELECTED_STYLE', styleData);
                        });
                        if (type === 'show-modal') {
                            const showModalLocalStorage =
                                localStorage.getItem('show-save-service-modal');

                            if (this.$mq === 'sm' || this.$mq === 'md') {
                                if (showModalLocalStorage) {
                                    if (showModalLocalStorage === 'show') {
                                        return (this.showNextServiceModal = true);
                                    } else {
                                        return;
                                    }
                                } else {
                                    this.showNextServiceModal = true;
                                }
                                return;
                            }

                            if (showModalLocalStorage) {
                                if (showModalLocalStorage === 'show') {
                                    return this.$modal.show('save-service');
                                } else {
                                    return;
                                }
                            } else {
                                this.$modal.show('save-service');
                                return;
                            }
                        } else if (type === 'change-service') {
                            this.$router.push(
                                `/${this.nextServiceTitle}/image_id=${this.orderMediaDetailsVS._id}`
                            );
                        } else {
                            this.$router.push('/project-overview');
                        }
                    }
                } else {

                    this.showNotification = true;
                    this.notificationStatus = 'warning';
                    this.notificationMessage =
                        'To add this service, you must first choose the room type and then the favorite style!';
                    setTimeout(() => {
                        this.showNotification = false;
                    }, 3500);
                }
            } catch (error) {
                // this.$store.commit('handleVsLoadingXS', false);
                this.savingService = false;

                const { status, data } = error.response;
                if (status === 400) {
                    this.showNotification = true;
                    this.notificationStatus = 'faild';
                    this.notificationMessage = data.message;

                    return;
                }
                this.showNotification = true;
                this.notificationStatus = 'faild';
                this.notificationMessage = 'An error occurred. Please try again';
            }

        },
    },
};
